import React, { Component } from 'react';
import { SingleDatePicker } from 'react-dates';
import { Table, Form, Segment, Button, Divider, } from 'semantic-ui-react';
import Select from 'react-select';
import { getPrintValues, checkAdminEmail } from '../../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import RenderItems from './RenderItems';
import axios from 'axios'
import { serverIp, firebaseAuth, toCurrency, logComponentLoad } from '../../../../config/constants.js'
import ViewUnPaidDaily from './ViewUnpaidDaily';
import BeyonicDeduction from './BeyonicDeduction';
//import { getShirtTypeDownDown } from '../dashBoard/newDashboard/LargeProjects/ApiUtils'
import { getShirtTypesToDisplay } from '../LargeProjects/ApiUtils'
import * as UiConsts from '../../../../config/UiConstants';
import PayTodaysItems from './PayTodaysItems';


class DailyExpenses extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dailyExpenseOptions: [],
            dailyExpense: '',
            newDailyExpense: '',
            amount: '',
            itemArray: [],
            runningTotal: '',
            shirtTypeOptions: [],
            loading: false,
        }
    }


    componentDidMount() {
        //1. GET MAIN CARD OBJECTS FROM ALGOLIA
        //getPrintValues("dailyExpenses", this.setDailyExpenseOptions);

        //getShirtTypesToDisplay(this.setShirtTypeDropDown, "daily_expenses");

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");

            if (user) {


                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }

        })
    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        //console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        //logComponentLoad(returnObject, "PaymentsPage", returnObject.algoliaUser.key);

        logComponentLoad(returnObject, "DailyExpenses");

       // if (returnObject.algoliaUser.dailyExpenses) { 
        if (returnObject.algoliaUser.perms.includes("daily_expenses")) {     
            console.log("returnObject.algoliaUser.dailyExpenses");
            //
            getShirtTypesToDisplay(this.setShirtTypeDropDown, "daily_expenses");

            // && this.state.algoliaUser.perms.includes("password_reset")
        } else if (returnObject.algoliaUser.perms.includes("sewing_supplies")) {
            console.log("returnObject.algoliaUser.dailyExpenses");
            //
            getShirtTypesToDisplay(this.setShirtTypeDropDown, "sewing_supplies");
        }

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    setShirtTypeDropDown = (shirtTypes) => {
        console.log("gshtx21 +++++++:setShirtTypeDropDown");
        // console.log("gshtx22:" + JSON.stringify(shirtTypes, null, 3));
        this.setState({
            dailyExpenseOptions: shirtTypes
        })

    }

    setDailyExpenseOptions = (objects) => {
        console.log("obx1 +++++++:setDailyExpenseOptions");
        // console.log("obx12 hits:"+JSON.stringify(objects, null, 3));
        this.setState({
            dailyExpenseOptions: objects
        })

    }

    handleDropDownChanges = (value) => {
        console.log("handleDropDownChanges");
        console.log('cv32 You\'ve sss:', value);
        console.log('cv32 You\'ve selected:', value.value + " " + value.category);


        this.setState({
            dailyExpense: value.value,
            newDailyExpense: value.label,
        });
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    dateSelectOnChange = (date) => {
        console.log("++++++++:dateSelectOnChange");
        console.log("date:" + date);
        console.log("date.getValue():" + date.valueOf());
        this.setState({
            date: date,
            dateNum: date.valueOf(),
            dateString: date.format('dddd MMMM Do')

        })
    }

    addItem = () => {
        console.log("++++++++:addItem");

        let item = {};
        //item.itemCode = this.state.dailyExpense;
        item.itemCode = this.state.newDailyExpense;
        item.amount = this.state.amount;
        item.notes = this.state.notes;

        console.log("itx1:" + JSON.stringify(item, null, 3));

        let tempArray = this.state.itemArray;
        tempArray.push(item);

        console.log("itx12 after adding item:" + JSON.stringify(item, null, 3));

        this.setState({
            itemArray: tempArray
        }, this.resetAfterAdding());
    }

    removeItem = (valueToRemove) => {
        console.log("itx21 ++++++ removeItem");
        let tempList = [];
        tempList = this.state.itemArray.filter(item => item !== valueToRemove)

        this.setState({
            itemArray: tempList
        })

        console.log("itx21 wishListJson size:" + tempList.length);
        console.log("itx21 wishListJson size:" + JSON.stringify(tempList, null, 3));
        //this.calculateTotal('deduct');
    }


    resetAfterAdding = () => {
        console.log("++++++++:resetAfterAdding");
        console.log("new state item array:" + JSON.stringify(this.state.itemArray))
        this.setState({
            dailyExpense: '',
            newDailyExpense: '',
            amount: '',
            notes: ''
            //itemArray:[]
        })
    }

    sendList = () => {
        console.log("++++++++:sendList");
        console.log("new state item array:" + JSON.stringify(this.state.itemArray));
        console.log("date:" + this.state.dateNum);

        this.setState({ loading: true });

        axios.post(serverIp + 'billing/sendDailyExpenses', {
            apiKey: "ad#4fsdUUddf",
            itemArray: this.state.itemArray,
            adminEmail: this.state.user.email,
            dateRequired: this.state.dateNum
        })
            .then((response) => {
                console.log(response.data);

                console.log("entx22 result:" + response.data.result);

                if (response.data.result) {

                    this.setState({ loading: false });

                    alert("expenses sent.");
                    this.setState({
                        dailyExpense: '',
                        newDailyExpense: '',
                        amount: '',
                        itemArray: []
                    })

                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                //this.setState({ loading: false })
            });

    }


    render() {

        // const amountUi = this.state.dailyExpense !== ''
        const amountUi = this.state.newDailyExpense !== ''
            ? <div>
                <Form.Field>
                    <label>Amount: {toCurrency(this.state.amount)} </label>
                    <Form.Input
                        fluid
                        name={'amount'}
                        value={this.state.amount}
                        icon='add user'
                        iconPosition='left'
                        placeholder='Amount'
                        // onFocus={props.amp_logFieldClick}
                        onChange={this.handleTextInputChange}
                        type='number'
                    />
                </Form.Field>
                <Form.Field>
                    <label>Notes (if applicable)</label>
                    <Form.Input
                        fluid
                        name={'notes'}
                        value={this.state.notes}
                        icon='add user'
                        iconPosition='left'
                        placeholder='Notes'
                        // onFocus={props.amp_logFieldClick}
                        onChange={this.handleTextInputChange}
                        type='text'
                    />
                </Form.Field>
            </div>
            : ''

        //const addButtonUi = this.state.dailyExpense !== '' && this.state.amount !== ''
        const addButtonUi = this.state.newDailyExpense !== '' && this.state.amount !== ''
            ? <Button color='green'> ADD </Button>
            : ''

        const itemArrayUI = this.state.itemArray.map((item) => <RenderItems item={item} removeItem={this.removeItem} />);

        const sendButtonUI = this.state.itemArray.length > 0
            ? <Button color='green' onClick={this.sendList}> SEND LIST </Button>
            : ''


        const deductionUi = this.state.user
            ? <BeyonicDeduction user={this.state.user} />
            : ''

        const userEmail = this.state.user && this.state.user.email
            ? <h3>{this.state.user.email}</h3>
            : 'no email'

        const payTodaysItems = this.state.user
            && this.state.user.email && this.state.algoliaUser != null
            && (this.state.algoliaUser.dailyExpenses && this.state.algoliaUser.perms.includes("payTodaysItems"))
            ? <PayTodaysItems user={this.state.user} />
            : ''

        const wholeUI = this.state.user
            && this.state.user.email && this.state.algoliaUser != null
            && (this.state.algoliaUser.dailyExpenses || this.state.algoliaUser.perms.includes("sewing_supplies"))
            ? <div>

                <Segment>
                    <Form fixed onSubmit={this.addItem}>
                        <SingleDatePicker
                            date={this.state.date} // momentPropTypes.momentObj or null
                            //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                            onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                            focused={this.state.focused} // PropTypes.bool
                            isOutsideRange={() => false}
                            onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                        />
                        <h2>{this.state.dateString}</h2>
                        {/* <label>{this.state.dailyExpense} </label> */}
                        <label>{this.state.newDailyExpense} </label>
                        <Select
                            name="form-field-name"
                            value={this.state.dailyExpense}
                            options={this.state.dailyExpenseOptions}
                            onChange={this.handleDropDownChanges}
                            searchable={true}
                            clearable={false}
                        />
                        {amountUi}
                        {addButtonUi}


                        <Divider horizontal>{'ITEM LIST'}</Divider>
                        {itemArrayUI}
                        {sendButtonUI}

                    </Form>
                </Segment>


                {/* <h1></h1>
                <h1>Make Payments</h1>
                <Divider horizontal>{'MAKE PAYMENTS'}</Divider>
                <ViewUnPaidDaily user={this.state.user} />

                <h1>Enter Deduction</h1>
                <Divider horizontal>{'ENTER DEDUCTION'}</Divider>
                {deductionUi} */}

            </div>
            : <div><h2>YOU ARE NOT AN AUTHORIZED</h2>{userEmail}</div>

        return (this.state.loading ? <UiConsts.LoadingComponent /> : <div>
            <h1>Enter Expenses</h1>
            {wholeUI}

            <br/>
            <Divider horizontal>{'PAY TODAYS STOCK ITEMS'}</Divider>
            {payTodaysItems}
        </div>);
    }
}

export default DailyExpenses;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Billing/DailyExpenses.js